import { css } from '@emotion/react';
import { pxToRem, weights } from '@upsun/react-component-library/src/styles/css-utils';
import React from 'react';
import { colors } from '../../utils/colors';

type DropdownProps = {
  isHourly: boolean,
  setIsHourly: (status : boolean) => void
};

const PricingToggle:React.FC<DropdownProps> = ({ isHourly, setIsHourly, ...props }) => {

  const containerStyles = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${pxToRem(8)};

    span {
      font-size: ${pxToRem(12)};
    }
  `;

  const toggle = css`
    width: ${pxToRem(32)};
    height: ${pxToRem(18)};
    border-radius: ${pxToRem(50)};
    background: ${!isHourly ? colors.black500 : colors.violet600};
    cursor: pointer;

    &::before {
      width: ${pxToRem(16)};
      height: ${pxToRem(16)};
      border-radius: 50%;
      display: block;
      background: #fff;
      content: "";
      transition: all 0.10s ease-in-out;
      position: relative;
      top: ${pxToRem(1)};
      left: ${!isHourly ? `calc(100% - ${pxToRem(18)})` : `${pxToRem(2)}`};
    }
  `;

  const hourlyMonthly = (hourly : boolean) => css`
    font-weight: ${isHourly === hourly ? weights.bold : weights.regular};
  `;

  return (
    <div css={containerStyles}>
      <span css={hourlyMonthly(true)}>Hourly</span>
      <div css={toggle} onClick={() => setIsHourly(!isHourly)}></div>
      <span css={hourlyMonthly(false)}>Monthly</span>
    </div>
  );
};

export default PricingToggle;